import { DataTableService } from 'src/app/shared/data-table/data-table.service';
import { TprAddReasonComponent } from './tpr-add-reason/tpr-add-reason.component';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CgpConfirmationDialogService } from '../../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';

import { ToastrService } from 'ngx-toastr';
import { TprReasonsApiService } from './tpr-reasons-modal.service';
import { LazyLoadEvent } from 'primeng/api/public_api';
import { ColumnDef, PageOptions } from '../../../../../shared/data-table/data-table.interface';
import { filter, finalize } from 'rxjs/operators';
import { DataTableValidators } from 'src/app/shared/data-table/validators';
import { Router } from '@angular/router';

@Component({
    selector: 'tpr-reasons-modal',
    templateUrl: './tpr-reasons-modal.template.html',
    styleUrls: ['../../../tprecm.style.scss', './tpr-reasons-modal.scss']
})
export class TprReasonModalComponent implements OnInit {

    fixtureNo: string = this.data.fixtureNo;
    partNumber: string = this.data.partNumber;

    reasonCodes: any[] = [];
    selectedReason: any;
    reasons: any[] = [];
    total = 0;
    loading = false;

    pageOptions: PageOptions = this.dataTableService.pageOptionsDefaultSort('reasDate');

    /**
     * Column names and values for the tprReasons table.
     * Matches the DTO.
     *
     * @type {any[]}
     * @memberof TprReasonModalComponent
     */
    columns: ColumnDef[] = [
        {
            field: 'reasonCodeId', name: 'Reason Code', width: '3em', type: 'dropdown',
            optionsList: this.reasonCodes, optionsListName: 'reasonCode', optionsListField: 'id',
            cellHoverInfo: (reasonCd: any) => {
                return [
                    { title: 'Reason Code', data: reasonCd.reasonCode },
                    { title: 'Area', data: reasonCd.area },
                    { title: 'Desc', data: reasonCd.description },
                    { title: 'Design Late Finish', data: reasonCd.designLateFinish },
                    { title: 'Construction Late Finish', data: reasonCd.constLateFinish },
                ];
            }
        },
        { field: 'reasDate', name: 'Date', width: '5em', type: 'date', tooltip: 'Reason Date' },
        { field: 'rationale', name: 'Rationale', validators: DataTableValidators.maxLength(325) },
        { field: 'desFinish', name: 'Design Finish', type: 'checkbox', width: '3em', tooltip: 'Check box if the design is finished.' },
        { field: 'bldFinish', name: 'Build Finish', type: 'checkbox', width: '3em', tooltip: 'Check box if the build has been finished.' },
    ];

    constructor(
        public readonly router: Router,
        private readonly dialogRef: MatDialogRef<TprReasonModalComponent>,
        private readonly dialog: MatDialog,
        private readonly toastr: ToastrService,
        private readonly service: TprReasonsApiService,
        private readonly confirmation: CgpConfirmationDialogService,
        @Inject(MAT_DIALOG_DATA) public readonly data: any,
        private readonly dataTableService: DataTableService
    ) {
    }

    loadReasons() {
        this.loading = true;

        this.service.getTprReasons(this.data.selectedToolId, this.pageOptions)
            .pipe(finalize(() => this.loading = false))
            .subscribe(response => {
                this.reasons = response.data;
                this.total = response.totalCount;
            });

        this.service.getTprReasonCodes()
            .subscribe(codes => {
                this.reasonCodes = codes;
                this.columns.find(column => column.field === 'reasonCodeId').optionsList = this.reasonCodes;
            });


        this.selectedReason = null;
    }

    onGridSelectionChange(event) {
        this.selectedReason = event;
    }

    pageOptionsChanged(event: LazyLoadEvent): boolean {
        return [
            this.pageOptions.order !== (event.sortOrder === 1 ? 'asc' : 'desc'),
            this.pageOptions.size !== event.rows,
            this.pageOptions.sort !== event.sortField,
            this.pageOptions.page !== event.first / this.pageOptions.size
        ].some(v => v);
    }

    onLazyLoad(event: LazyLoadEvent) {
        if (!this.pageOptionsChanged(event)) {
            return;
        }

        this.pageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
        this.pageOptions.size = event.rows;
        this.pageOptions.sort = event.sortField;
        this.pageOptions.page = event.first / this.pageOptions.size;

        this.loadReasons();
    }

    onAddReasonClick() {
        const dialogRef = this.dialog.open(TprAddReasonComponent, {
            disableClose: true,
            data: {
                reasonCodes: this.reasonCodes,
                toolId: this.data.selectedToolId
            },
        });

        dialogRef.afterClosed()
            .pipe(filter(Boolean))
            .subscribe(() => {
                this.pageOptions.sort = 'id';
                this.pageOptions.order = 'desc';
                this.loadReasons();
            });
    }

    removeHandler() {
        if (!this.selectedReason) {
            this.toastr.error('Please select a reason');
            return;
        }

        const code = this.reasonCodes.find(reasonCode => reasonCode.id === this.selectedReason.reasonCodeId);

        this.confirmation.showConfirmationDialog({
            title: 'TPRECM',
            message: `Are you sure you want to delete Reason '${code ? code.reasonCode : 'Unknown Code'}'?`,
            alert: 'danger',
            onYesClick: () => {
                this.service.deleteTprReason(this.selectedReason.id)
                    .subscribe(() => this.loadReasons());

                this.confirmation.closeConfirmationDialog();
            },
            onNoClick: () => this.confirmation.closeConfirmationDialog()
        });
    }

    saveHandler(dataItem: any) {
        this.service.updateTprReason(dataItem.data)
            .pipe(finalize(() => this.loadReasons()))
            .subscribe();
    }

    ngOnInit(): void {
        this.loadReasons();

        if (this.router.url === '/tprecm/view-update-tpr/re-source') {
            this.columns.forEach(val => { val.editable = false; val.headerHighlight = false; });
            this.columns.forEach(val => {
                if (val.field === 'reasonCodeId' || val.field === 'reasDate' || val.field === 'rationale' ||
                    val.field === 'desFinish' || val.field === 'bldFinish') {
                    return (val.type = 'readonly');
                }
            });
        }
    }
}
